import React from "react";
import { gymConfig } from "./gymConfig";

const themeEntries = [
  ["--color-page-background", gymConfig.theme.pageBackground],
  ["--color-page-text", gymConfig.theme.pageText],
  ["--color-text-muted", gymConfig.theme.textMuted],
  ["--color-text-subtle", gymConfig.theme.textSubtle],
  ["--color-border", gymConfig.theme.border],
  ["--color-surface", gymConfig.theme.surface],
  ["--color-surface-elevated", gymConfig.theme.surfaceElevated],
  ["--auth-panel-background", gymConfig.theme.authPanelBackground],
  ["--auth-panel-glow", gymConfig.theme.authPanelGlow],
  ["--button-primary-background", gymConfig.theme.buttonPrimary],
  ["--button-primary-text", gymConfig.theme.buttonPrimaryText],
  ["--button-secondary-background", gymConfig.theme.buttonSecondaryBackground],
  ["--button-secondary-border", gymConfig.theme.buttonSecondaryBorder],
  ["--button-secondary-text", gymConfig.theme.buttonSecondaryText],
  ["--input-background", gymConfig.theme.inputBackground],
  ["--input-border", gymConfig.theme.inputBorder],
  ["--input-focus-border", gymConfig.theme.inputFocusBorder],
  ["--status-primary-background", gymConfig.theme.primarySoftBackground],
  ["--status-primary-border", gymConfig.theme.primarySoftBorder],
  ["--status-primary-text", gymConfig.theme.primarySoftText],
  ["--status-success-background", gymConfig.theme.successSoftBackground],
  ["--status-success-border", gymConfig.theme.successSoftBorder],
  ["--status-success-text", gymConfig.theme.successSoftText],
  ["--status-danger-background", gymConfig.theme.dangerSoftBackground],
  ["--status-danger-border", gymConfig.theme.dangerSoftBorder],
  ["--status-danger-text", gymConfig.theme.dangerSoftText],
  ["--nav-active-background", gymConfig.theme.navActiveBackground],
  ["--nav-active-border", gymConfig.theme.navActiveBorder],
  ["--nav-active-text", gymConfig.theme.navActiveText],
  ["--link-accent", gymConfig.theme.linkAccent],
  ["--brand-accent", gymConfig.theme.accent],
  ["--brand-accent-strong", gymConfig.theme.accentStrong],
] as const;

function syncDocumentBranding() {
  if (typeof document === "undefined") return;

  document.title = gymConfig.brand.shortName;

  const metaDescription = document.querySelector('meta[name="description"]');
  metaDescription?.setAttribute("content", gymConfig.brand.description);

  const metaThemeColor = document.querySelector('meta[name="theme-color"]');
  metaThemeColor?.setAttribute("content", gymConfig.theme.pageBackground);

  const appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  appleTitle?.setAttribute("content", gymConfig.brand.installName);

  const favicon = document.querySelector('link[rel="icon"]');
  favicon?.setAttribute("href", gymConfig.assets.faviconUrl);

  const appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');
  appleTouchIcon?.setAttribute("href", gymConfig.assets.logoUrl);
}

function applyThemeVariables() {
  if (typeof document === "undefined") return;

  const root = document.documentElement;
  for (const [key, value] of themeEntries) {
    root.style.setProperty(key, value);
  }
}

export default function AppBrandingProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  React.useEffect(() => {
    applyThemeVariables();
    syncDocumentBranding();
  }, []);

  return <>{children}</>;
}
